import { Form as AntForm, FormProps } from 'antd';
import clx from 'classnames';
import * as React from 'react';

export interface IStyledFormProps extends FormProps {
  children: React.ReactNode;
}

/**
 * Impostazione di base per applicare gli stili al Form
 */
export function StyledForm(props: IStyledFormProps) {
  const { className, children, ...otherProps } = props;

  return (
    <AntForm
      layout="vertical"
      component="div"
      className={clx('form-handler', className)}
      {...otherProps}
    >
      {children}
    </AntForm>
  );
}
